module.exports = __webpack_public_path__ + "img/catalogue.394e0588.jpg";